import { useEffect, useState } from "react";

export default function useTransparentState<T>(
  externalState: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(externalState);

  useEffect(() => {
    setState(externalState);
  }, [externalState]);

  return [state, setState];
}
